<template>
  <!-- 日期选择弹窗 -->
  <div class="image-select">
    <van-popup v-model="show" position="bottom">
      <div class="btn-list">
        <div class="btn" @click="clickFile('file2')">拍照</div>
        <div class="btn" @click="clickFile('file1')">从相册选择</div>
        <div class="btn cancel" @click="show=false">取消</div>
      </div>
    </van-popup>
    <input type="file" accept="*.jpg,*.png" ref="file1" @change="selectFile">
    <input type="file" accept="image/*" capture="camera" ref="file2" @change="selectFile">
  </div>
</template>

<script>
import {common} from "@/api/mixins";
export default {
  mixins: [common],
  data() {
    return {
      show:false
    };
  },
  mounted() {

  },
  methods: {
    open(){
      if(this.$config.isAndroid){
        this.show = true;
      }else{
        this.clickFile('file1');
      }
    },
    // 选择文件回调
    selectFile(e){
      console.log(e.target.files);
      if(e.target.files.length==0){
        // this.$notice.msg("未选择任何文件");
        return;
      }
      this.show = false;
      this.loading = true;
      const formData = new FormData();
      formData.append('file',e.target.files[0]);
      this.$http({
        url:"/resmgr/upload",
        type:"POST",
        data:formData,
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(res=>{
        this.loading = false;
        this.$notice.msg("上传成功");
        this.$emit("submit",res.data[0]);
      })
    },
    // 点击文件选取
    clickFile(key){
      this.$refs[key].dispatchEvent(new MouseEvent('click'))
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./imageSelect.scss";
</style>
